import React, {useEffect, useState} from 'react';
import {Layout, Menu} from "antd";
import MenuItem from "../../components/Common/MenuItem";
import {
    BarsOutlined, CommentOutlined,
    ScheduleOutlined,
} from "@ant-design/icons";
import {useLocation, useNavigate} from "react-router-dom";
import UserProfile from "./UserProfile";
import UseTranslate from "../../hooks/UseTranslate";

const AppSider = () => {
    const { Sider } = Layout;
    const navigate = useNavigate();
    const location = useLocation().pathname;
    const [selectKey, setSelectKey] = useState('/case');
    const translate = UseTranslate();

    useEffect(() => {
        if (location.includes('/review')) {
            return setSelectKey('/case');
        }
        setSelectKey(location);
    }, [location]);

    const onClickMain = () => {
        navigate('/case');
    }

    const onClickMenu = (e) => {
        navigate(e.key);
    }

    const menuItems = [
        //  추후 대시보드 개발 시 추가
        // MenuItem(UseTranslate('home'), '/home', <HomeOutlined />),
        MenuItem(translate('viewCase'), '/case', <BarsOutlined />),
        MenuItem(translate('inquiry'), '/inquiry', <CommentOutlined />),
        MenuItem(translate('createMeeting'), '/schedule', <ScheduleOutlined />),
    ]

    return (
        <Sider style={{backgroundColor: 'rgb(220, 220, 220)'}}>
            <div style={{cursor: 'pointer', height: 64, width: '100%', textAlign: 'center', backgroundColor: '#ffffff'}} onClick={onClickMain}>
                <img alt='logo' src='/images/asan_logo.png' style={{maxWidth: '100%', maxHeight: '100%', padding: '0.5rem'}}/>
            </div>
            <UserProfile />
            <Menu mode='inline' selectedKeys={[selectKey]} onClick={onClickMenu} items={menuItems} style={{backgroundColor: 'rgb(220, 220, 220)', borderInlineEnd: 'none'}}/>
        </Sider>
    );
};

export default AppSider;